import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classnames from 'classnames';
import EmtyCard from '@/components/base/EmptyCard';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Descriptions = function(props) {
    var title = props.title, titleClassName = props.titleClassName, className = props.className, style = props.style, children = props.children;
    return(/*#__PURE__*/ _jsx(EmtyCard, {
        className: classnames([
            className
        ]),
        style: style,
        title: title,
        titleClassName: titleClassName,
        children: /*#__PURE__*/ _jsx("div", {
            className: "bg-box rounded-[8px] p-[30px] px-[55px]",
            children: children
        })
    }));
};
var StyledDescriptionLadder = styled.section.withConfig({
    displayName: "Descriptions__StyledDescriptionLadder",
    componentId: "sc-dwgfdi-0"
})([
    "position:relative;margin-left:86px;&::before{position:absolute;content:'';left:0;bottom:10px;width:1px;height:100%;background-color:#e5e6eb;}> .description-item{position:relative;> dt{",
    " &::before{position:absolute;content:'';left:0;top:50%;transform:translate(0,-50%);width:10px;height:1px;background-color:#e5e6eb;}}> dt{",
    "}}"
], {
    "paddingLeft": "16px"
}, {
    "color": "var(--color-text-secondary)"
});
var DescriptionItem = function(props) {
    var label = props.label, children = props.children, width = props.width, _style = props.style, style = _style === void 0 ? {} : _style, _skeleton = props.skeleton, skeleton = _skeleton === void 0 ? false : _skeleton, skeletonOption = props.skeletonOption, _className = props.className, className = _className === void 0 ? '' : _className, _labelClassName = props.labelClassName, labelClassName = _labelClassName === void 0 ? '' : _labelClassName, _valueClassName = props.valueClassName, valueClassName = _valueClassName === void 0 ? '' : _valueClassName;
    var s = Object.assign(style, {
        width: width
    });
    return(/*#__PURE__*/ _jsxs("dl", {
        className: "description-item flex items-center mb-[24px] last:mb-0 ".concat(className),
        style: s,
        children: [
            /*#__PURE__*/ _jsxs("dt", {
                className: "min-w-[280px] text-[16px] leading-[24px] text-secondary ".concat(labelClassName),
                children: [
                    label,
                    ":"
                ]
            }),
            skeleton && /*#__PURE__*/ _jsx("dd", {
                className: "flex-1 text-[16px] leading-[24px]",
                children: /*#__PURE__*/ _jsx(Skeleton, {
                    width: (skeletonOption === null || skeletonOption === void 0 ? void 0 : skeletonOption.width) || 250,
                    height: skeletonOption === null || skeletonOption === void 0 ? void 0 : skeletonOption.height
                })
            }),
            !skeleton && /*#__PURE__*/ _jsx("dd", {
                className: "flex-1 text-[16px] leading-[20px] ".concat(valueClassName),
                children: children
            })
        ]
    }));
};
var DescriptionGroup = function(props) {
    var children = props.children, line = props.line, rest = _objectWithoutProperties(props, [
        "children",
        "line"
    ]);
    return(/*#__PURE__*/ _jsx("div", _objectSpread({
        className: classnames([
            {
                'border-b-[1px] pb-[24px] mb-[24px]': line
            }
        ])
    }, rest, {
        children: children
    })));
};
var DescriptionLadder = function(props) {
    var children = props.children, rest = _objectWithoutProperties(props, [
        "children"
    ]);
    return(/*#__PURE__*/ _jsx(StyledDescriptionLadder, _objectSpread({}, rest, {
        children: children
    })));
};
Descriptions.Item = DescriptionItem;
Descriptions.Group = DescriptionGroup;
Descriptions.Ladder = DescriptionLadder;
export default Descriptions;
